    /*
    목적: 즉시 토큰 유효성 검증
    역할:
    토큰 존재 여부 확인
    토큰 만료 시간 체크
    검증 결과 반환
    특징: 요청 시점에만 실행 (함수 호출 기반)
    동기적 검증
    결과 반환 시스템

    */
    /**
     * 토큰 검증 및 인증 관련 유틸리티 함수들
     */

    export interface TokenValidationResult {
    isValid: boolean;
    reason?: 'no-tokens' | 'refresh-expired' | 'invalid-token' | 'access-expired';
    }

    /**
     * 토큰 존재 여부만 확인
     */
    export const hasTokens = (): boolean => {
    const accessToken = localStorage.getItem('access-token');
    const refreshToken = localStorage.getItem('refresh-token');
    return !!(accessToken && refreshToken);
    };

    /**
     * RefreshToken 만료 시간 체크
     */
    export const isRefreshTokenExpired = (): boolean => {
    const refreshToken = localStorage.getItem('refresh-token');
    if (!refreshToken) return true;

    try {
        const refreshPayload = JSON.parse(atob(refreshToken.split('.')[1]));
        const refreshExp = refreshPayload.exp * 1000;
        const now = Date.now();
        return now >= refreshExp;
    } catch (error) {
        console.error('❌ RefreshToken 파싱 오류:', error);
        return true;
    }
    };

    /**
     * AccessToken 만료 시간 체크
     */
    export const isAccessTokenExpired = (): boolean => {
    const accessToken = localStorage.getItem('access-token');
    if (!accessToken) return true;

    try {
        const accessPayload = JSON.parse(atob(accessToken.split('.')[1]));
        const accessExp = accessPayload.exp * 1000;
        const now = Date.now();
        return now >= accessExp;
    } catch (error) {
        console.error('❌ AccessToken 파싱 오류:', error);
        return true;
    }
    };

    /**
     * 토큰 유효성 검증 (HomeContainer용)
     * - 토큰 존재 여부
     * - RefreshToken 만료 여부
     */
    export const validateTokensForAppStart = (): TokenValidationResult => {
    // 1. 토큰 존재 여부 체크
    if (!hasTokens()) {
        console.log('🔑 토큰 없음');
        return { isValid: false, reason: 'no-tokens' };
    }

    // 2. RefreshToken 만료 체크
    if (isRefreshTokenExpired()) {
        console.log('⏰ RefreshToken 만료됨');
        return { isValid: false, reason: 'refresh-expired' };
    }

    console.log('✅ 토큰 유효 - 앱 시작');
    return { isValid: true };
    };

/**
 * 토큰 유효성 검증 (API 호출용)
 * - AccessToken 만료 여부만 체크 (RefreshToken은 axiosInterceptor에서 처리)
 */
    export const validateTokensForApiCall = (): TokenValidationResult => {
    if (!hasTokens()) {
        return { isValid: false, reason: 'no-tokens' };
    }

    if (isAccessTokenExpired()) {
        return { isValid: false, reason: 'access-expired' };
    }

    return { isValid: true };
    };

/**
 * 로그인 페이지로 이동 (일관된 방식)
 * sessionErrorHandler.ts의 redirectToSignin과 중복이므로 제거
 * sessionErrorHandler.ts의 함수를 사용하도록 변경
 */
